import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./FotoFunMobileApplyButton.module.scss";

interface FotoFunMobileApplyButtonProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
}

export const FotoFunMobileApplyButton = ({
    onClick,
    className = ""
}: FotoFunMobileApplyButtonProps) => {
    const { t } = useTranslation();

    return (
        <button
            className={`${styles.FotoFunMobileApplyButton} ${className}`}
            onClick={onClick}
        >
            <span className={styles.gradient}></span>
            <span className={styles.text}>{t("photo_prints.apply")}</span>
        </button>
    );
};